import AdminTradingPacks from './AdminTradingPacks';

export default AdminTradingPacks;
